import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../Components/Layout/Body/index";
import { Login } from "../Pages/Login";
import { LandingPage } from "../Pages/LandingPage";
import { LoginLandingPage } from "../Pages/LoginLanding";
import ProtectedRoute from "../RouterPath/protectedRoute";
import PrivacyPolicy from "../Pages/Privacy";
import TermsAndConditions from "../Pages/TermsAndCondition";

const RoutePath = ({ isDarkTheme }) => {
  useEffect(() => {
    const handleInvalidToken = (e) => {
      if (e.key === "apptoken" && e.oldValue && !e.newValue) {}
    };
    window.addEventListener("storage", handleInvalidToken);
    return () => window.removeEventListener("storage", handleInvalidToken);
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route element={<Layout isDarkTheme={isDarkTheme} />}>
          {/* Public Routes */}
          <Route path="/" element={<LoginLandingPage />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />

          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
          </Route>
        </Route>
      </Routes>
    </div>
  );
};

export default RoutePath;

